import { createSlice } from "@reduxjs/toolkit";

const doctorSlice = createSlice({
  name: "doctors",
  initialState: {
    isFetching: false,
    doctors: [],
    error: []
  },
  reducers: {
    statusDoctorStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusDoctorSuccess: (state, action) => {
      state.isFetching = false
      state.doctors = action.payload
      state.error = []
    },
    statusDoctorFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusDoctorStart,
  statusDoctorSuccess,
  statusDoctorFailure 
} = doctorSlice.actions

export default doctorSlice.reducer